import styled from 'styled-components';
import { Typography } from 'src/ui/common/atoms/typography';
import { media } from 'src/ui/common/mixins/media';

export const StyledItem = styled.div`
  padding: 10px 15px;
  background: ${({ theme }) => theme.colors.gs500};
  border-radius: 5px;

  ${media.md`
    padding: 12px 15px;
  `}
`;

export const StyledItemValue = styled(Typography)`
  color: white;
  
  ${media.md`
    font-size: 20px;
  `}
`;

export const StyledItemLabel = styled(Typography)`
  color: #B7B7B7;
  margin-top: 5px;
  white-space: nowrap;

  ${media.md`
    font-size: 14px;
  `}
`;
